import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/apps/web/app/_layout/footer/index.tsx");
